import { __decorate } from "tslib";
import { isEmpty } from 'lodash';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    value = '';
    gender = '';
    options = [{
            value: '男',
            label: this.$t('male')
        }, {
            value: '女',
            label: this.$t('female')
        }];
    onChange(v) {
        this.$emit('change', v);
    }
    onCreate(gender) {
        if (isEmpty(this.value) && !isEmpty(gender)) {
            this.value = gender;
        }
    }
};
__decorate([
    Prop()
], default_1.prototype, "gender", void 0);
__decorate([
    Watch('value')
], default_1.prototype, "onChange", null);
__decorate([
    Watch('gender')
], default_1.prototype, "onCreate", null);
default_1 = __decorate([
    Component({
        name: 'genderSelect',
        i18n: {
            messages: {
                en: {
                    male: 'Male',
                    female: 'Female',
                    placeholder: 'Please select'
                },
                zh: {
                    male: '男',
                    female: '女',
                    placeholder: '请选择'
                },
            },
        },
    })
], default_1);
export default default_1;
